import React from 'react';
import { createRoot } from "react-dom/client";
import App from "../src/App";

const jwtContainer = document.getElementById('jwt_token')

if(jwtContainer) {
    const root = createRoot(jwtContainer);
    if (root) {
        const auth0Audience = document.querySelector('meta[name="audience"]').content
        const clientId = document.querySelector('meta[name="clientId"]').content
        const auth0Connection = document.querySelector('meta[name="connection"]').content
        const auth0domain = document.querySelector('meta[name="domain"]').content
        const auth0LogoutUrl = document.querySelector('meta[name="auth0LogoutUrl"]').content
        const cpgLogoutUrl = document.querySelector('meta[name="cpgLogoutUrl"]').content

        root.render(<App audience={auth0Audience} clientId={clientId} connection={auth0Connection} auth0LogoutUrl={auth0LogoutUrl} cpgLogoutUrl={cpgLogoutUrl} domain={auth0domain} />);
    }
}